module.exports = __webpack_public_path__ + "img/DUCATI.6a912b7.jpg";